/**
 * Product Add-ons
 * Pairs with sections/product-addons.liquid.
 *
 * Finds the main product's Add to Cart form on the page, reads the
 * currently selected variant, and combines it with any checked add-on
 * products into a single /cart/add.js request. Reuses the Impulse
 * theme's own "ajaxProduct:added" event so the existing cart drawer
 * refreshes and opens the same way it does for a normal Add to Cart.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      var format = (window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
      return window.theme.Currency.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function init(container) {
    var variants = [];
    try {
      variants = JSON.parse(container.getAttribute('data-addons-variants') || '[]');
    } catch (e) {
      variants = [];
    }

    var formSelector = container.getAttribute('data-product-form-selector') || '.product-single__form';
    var redirectToCart = container.getAttribute('data-redirect-to-cart') === 'true';
    var form =
      document.querySelector(formSelector) ||
      document.querySelector('form[action*="/cart/add"]');

    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var quantityInput = form ? form.querySelector('[name="quantity"]') : null;

    // Our button already adds the main product + selected add-ons together,
    // so hide the theme's own plain Add to Cart button to avoid two
    // side-by-side buttons. Leave express-checkout buttons (Shop Pay, Buy it
    // now, etc.) alone since those are a separate purchase path.
    var nativeAddButton = form ? form.querySelector('[name="add"]') : null;
    if (nativeAddButton) nativeAddButton.style.display = 'none';

    var checkboxes = Array.prototype.slice.call(container.querySelectorAll('[data-addon-checkbox]'));
    var totalEl = container.querySelector('[data-addons-total]');
    var addButton = container.querySelector('[data-addons-add-to-cart]');
    var addButtonText = container.querySelector('[data-addons-btn-text]');
    var messageEl = container.querySelector('[data-addons-message]');

    function getMainVariant() {
      if (!variantInput || !variants.length) return variants[0] || null;
      var id = variantInput.value;
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) {
          match = variants[i];
          break;
        }
      }
      return match || variants[0];
    }

    function getQuantity() {
      if (!quantityInput) return 1;
      var qty = parseInt(quantityInput.value, 10);
      return qty > 0 ? qty : 1;
    }

    function updateTotal() {
      if (!totalEl) return;
      var mainVariant = getMainVariant();
      var qty = getQuantity();
      var total = mainVariant ? mainVariant.price * qty : 0;
      checkboxes.forEach(function (cb) {
        if (cb.checked) total += parseInt(cb.dataset.price, 10) || 0;
      });
      totalEl.textContent = formatMoney(total);
    }

    function showMessage(text, isError) {
      if (!messageEl) return;
      messageEl.textContent = text;
      messageEl.classList.toggle('product-addons__message--error', !!isError);
    }

    var originalButtonText = addButtonText ? addButtonText.textContent : null;

    function setLoading(isLoading) {
      if (!addButton) return;
      addButton.disabled = isLoading;
      addButton.classList.toggle('is-loading', isLoading);
      if (addButtonText) {
        addButtonText.textContent = isLoading ? 'Adding...' : originalButtonText;
      }
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', updateTotal);
    });
    if (variantInput) variantInput.addEventListener('change', updateTotal);
    if (quantityInput) quantityInput.addEventListener('change', updateTotal);

    updateTotal();

    if (addButton) {
      addButton.addEventListener('click', function () {
        var mainVariant = getMainVariant();
        if (!mainVariant || mainVariant.available === false) {
          showMessage('This product is currently unavailable.', true);
          return;
        }

        var items = [{ id: mainVariant.id, quantity: getQuantity() }];
        checkboxes.forEach(function (cb) {
          if (cb.checked) {
            items.push({ id: parseInt(cb.value, 10), quantity: 1 });
          }
        });

        setLoading(true);
        showMessage('', false);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                throw new Error(data.description || data.message || 'Could not add items to cart.');
              }
              return data;
            });
          })
          .then(function () {
            if (redirectToCart) {
              window.location.href = '/cart';
              return;
            }
            showMessage('Added to cart.', false);
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
          })
          .catch(function (err) {
            showMessage(err.message || 'Something went wrong adding items to cart.', true);
          })
          .finally(function () {
            setLoading(false);
          });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('[data-product-addons-section]');
    containers.forEach(init);
  });
})();